export const entityName = 'Specialists Groups';